module.exports = __webpack_public_path__ + "img/urbanpiper.4e4f92d3.png";